/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Feature_Cover_LettersInputs */

const en_settings_feature_cover_letters = /** @type {(inputs: Settings_Feature_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover letters`)
};

const de_settings_feature_cover_letters = /** @type {(inputs: Settings_Feature_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschreiben`)
};

const fr_settings_feature_cover_letters = /** @type {(inputs: Settings_Feature_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettres de motivation`)
};

const es_settings_feature_cover_letters = /** @type {(inputs: Settings_Feature_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartas de presentación`)
};

const it_settings_feature_cover_letters = /** @type {(inputs: Settings_Feature_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettere di presentazione`)
};

const nl_settings_feature_cover_letters = /** @type {(inputs: Settings_Feature_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motieven`)
};

const pl_settings_feature_cover_letters = /** @type {(inputs: Settings_Feature_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listy motywacyjne`)
};

const fi_settings_feature_cover_letters = /** @type {(inputs: Settings_Feature_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kansilehdet`)
};

const da_settings_feature_cover_letters = /** @type {(inputs: Settings_Feature_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgningsbreve`)
};

const sv_settings_feature_cover_letters = /** @type {(inputs: Settings_Feature_Cover_LettersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansökningsbrev`)
};

/**
* | output |
* | --- |
* | "Cover letters" |
*
* @param {Settings_Feature_Cover_LettersInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_feature_cover_letters = /** @type {((inputs?: Settings_Feature_Cover_LettersInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Feature_Cover_LettersInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_feature_cover_letters(inputs)
	if (locale === "fr") return fr_settings_feature_cover_letters(inputs)
	if (locale === "es") return es_settings_feature_cover_letters(inputs)
	if (locale === "it") return it_settings_feature_cover_letters(inputs)
	if (locale === "nl") return nl_settings_feature_cover_letters(inputs)
	if (locale === "pl") return pl_settings_feature_cover_letters(inputs)
	if (locale === "fi") return fi_settings_feature_cover_letters(inputs)
	if (locale === "da") return da_settings_feature_cover_letters(inputs)
	if (locale === "sv") return sv_settings_feature_cover_letters(inputs)
	return en_settings_feature_cover_letters(inputs)
});